import { computed as t, createElementBlock as i, openBlock as r, createVNode as c, renderSlot as n, createCommentVNode as o, normalizeProps as m, guardReactiveProps as u, createElementVNode as y, normalizeClass as v, toDisplayString as p } from "vue";
import { A as h } from "./AvatarIcon.Bdl_dbsV.js";
import { format as f } from "date-fns";
import '../../assets/components/UserDisplay.css';const g = ["aria-label"], N = ["title"], w = {
  __name: "UserDisplay",
  props: {
    userId: {
      type: String,
      required: !0
    },
    displayName: {
      type: String,
      required: !0
    },
    scale: {
      type: Number,
      default: 1
    },
    clickable: {
      type: Boolean,
      default: !1
    },
    archivedOn: {
      type: Date,
      default: null
    },
    showLargeArchivedBadge: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const a = e, l = t(() => a.archivedOn != null), s = t(
      () => (
        /* v8 ignore next - unreachable else in practice since title only renders when archivedOn exists */
        a.archivedOn ? f(a.archivedOn, "dd-MM-yyyy") : ""
      )
    );
    return (d, b) => (r(), i("div", {
      class: "cc-user-display d-inline-flex flex-row align-items-baseline",
      "data-dd-privacy": "mask",
      "aria-label": e.displayName
    }, [
      c(h, {
        id: e.userId,
        class: "me-1",
        "display-name": e.displayName,
        scale: e.scale,
        "is-archived": l.value
      }, null, 8, ["id", "display-name", "scale", "is-archived"]),
      n(d.$slots, "name", m(u({ displayName: e.displayName })), () => [
        y("span", {
          class: v(["user-name", { "archived text-muted": l.value }])
        }, p(e.displayName), 3)
      ]),
      e.showLargeArchivedBadge && l.value ? (r(), i("span", {
        key: 0,
        class: "badge rounded-pill client-badge bg-secondary ms-1",
        title: `This user was archived on ${s.value}`
      }, " Archived ", 8, N)) : o("", !0)
    ], 8, g));
  }
};
export {
  w as _
};
